import { useColorMode } from '@chakra-ui/react';
import { useMemo } from 'react';
import { useCalendarSettings } from '../../../lib';

export const MonthDateHeader = ({ label, date, drilldownView, onDrillDown }) => {
	const { settings } = useCalendarSettings();
	const { colorMode } = useColorMode();

	const today = new Date();
	const isPast = date < new Date(today.setHours(0, 0, 0, 0));
	const style = useMemo(
		() => ({ color: isPast ? 'lightgray' : settings.styles[colorMode].calendarTextColor }),
		[settings.styles, colorMode, isPast]
	);

	if (!drilldownView) {
		return <span style={style}>{label}</span>;
	}
	return (
		<button type='button' className='rbc-button-link' style={style} onClick={onDrillDown}>
			{label}
		</button>
	);
};
